module.exports = function getResource(label, vars = []) {
    let resources = {
        makeoverAt: 'Séance maquillage chez'
    };

    return resources[label];
};
